import axios from '../axios'
// 基础价格本列表
export const getBasePriceBookPage = (data) => {
  return axios({
    url: '/api/sys/getBasePriceBookPage',
    method: 'post',
    data
  })
}
// 基础价格本列表删除
export const deleteBasePriceBooks = (data) => {
  return axios({
    url: '/api/sys/deleteBasePriceBooks',
    method: 'post',
    data
  })
}
// 基础价格本列表保存
export const saveBasePriceBook = (data) => {
  return axios({
    url: '/api/sys/saveBasePriceBook',
    method: 'post',
    data
  })
}
// 基础价格本列表修改
export const updateBasePriceBook = (data) => {
  return axios({
    url: '/api/sys/updateBasePriceBook',
    method: 'post',
    data
  })
}
// 基础价格本列表价格本第一次审核
export const auditBasePriceBookByStatusFirst = (data) => {
  return axios({
    url: '/api/sys/auditBasePriceBookByStatusFirst',
    method: 'post',
    data
  })
}
// 基础价格本列表价格本第二次审核
export const auditBasePriceBookByStatusSecond = (data) => {
  return axios({
    url: '/api/sys/auditBasePriceBookByStatusSecond',
    method: 'post',
    data
  })
}
// 最新生效的区域价格本
export const inEffectBasePriceAreaPage = (data) => {
  return axios({
    url: '/api/sys/base/inEffectBasePriceAreaPage',
    method: 'post',
    data
  })
}
// 价格本生效
export const TakeEffectBasePriceBook = (data) => {
  return axios({
    url: '/api/sys/TakeEffectBasePriceBook',
    method: 'post',
    data
  })
}
// 价格本作废
export const InvalidBasePriceBook = (data) => {
  return axios({
    url: '/api/sys/InvalidBasePriceBook',
    method: 'post',
    data
  })
}


// 区域加价表列表
export const getBaseAddAreaPage = (data) => {
  return axios({
    url: '/api/sys/base/getBaseAddAreaPage',
    method: 'post',
    data
  })
}
// 区域加价表列表保存
export const saveBaseAddArea = (data) => {
  return axios({
    url: '/api/sys/base/saveBaseAddArea',
    method: 'post',
    data
  })
}
// 区域加价表列表批量保存
export const saveBaseAddAreaBatch = (data) => {
  return axios({
    url: '/api/sys/base/saveBaseAddAreaBatch',
    method: 'post',
    data
  })
}
// 区域加价表列表删除
export const deleteBaseAddAreas = (data) => {
  return axios({
    url: '/api/sys/base/deleteBaseAddAreas',
    method: 'post',
    data
  })
}
// 区域加价表列表修改
export const updateBaseAddArea = (data) => {
  return axios({
    url: '/api/sys/base/updateBaseAddArea',
    method: 'post',
    data
  })
}
// 区域加价表列表批量修改
export const updateBaseAddAreaBatch = (data) => {
  return axios({
    url: '/api/sys/base/updateBaseAddAreaBatch',
    method: 'post',
    data
  })
}
// 复制保存价格本
export const copySaveBasePriceBook = (data) => {
  return axios({
    url: '/api/sys/copySaveBasePriceBook',
    method: 'post',
    data
  })
}
// 批量保存_最终加价新增区域
export const batchSaveBasePriceAreaFinalPrice = (data) => {
  return axios({
    url: '/api/sys/base/batchSaveBasePriceAreaFinalPrice',
    method: 'post',
    data
  })
}
// 批量修改_最终加价修改，传id和最终价
export const updateBasePriceAreaFinalPriceBatch = (data) => {
  return axios({
    url: '/api/sys/base/updateBasePriceAreaFinalPriceBatch',
    method: 'post',
    data
  })
}


// WEBPACK FOOTER //
// ./src/api/moudules/priceBook.js